import { POPPER_Z_INDEX } from '@/core/constants/layout';

export const fieldPickerStyles = {
	popper: {
		zIndex: POPPER_Z_INDEX
	},

	paper: {
		width: 320,
		maxHeight: 360,
		display: 'flex',
		flexDirection: 'column',
		border: '1px solid',
		borderColor: 'divider',
		borderRadius: 1,
		backgroundColor: 'background.paper',
		boxShadow: 4,
		overflow: 'hidden'
	},

	searchWrap: {
		p: 1,
		borderBottom: '1px solid',
		borderColor: 'divider'
	},

	list: {
		overflowY: 'auto',
		flex: 1
	},

	groupLabel: {
		px: 1.5,
		pt: 1.25,
		pb: 0.5,
		fontSize: '0.75rem',
		fontWeight: 700,
		color: 'text.secondary',
		textTransform: 'uppercase',
		letterSpacing: '0.08em'
	},

	item: {
		px: 1.5,
		py: 1,
		cursor: 'pointer',
		fontSize: '0.875rem',
		color: 'text.primary',

		'&:hover': {
			backgroundColor: 'primary.lighter'
		}
	},

	itemHighlighted: {
		backgroundColor: 'primary.lighter'
	},

	noResults: {
		p: 2,
		textAlign: 'center',
		color: 'text.secondary',
		fontSize: '0.875rem'
	}
};
